<template>
  <div>
    <customList :filterItems="formItems" :filterModel="filter"  @selectChange="selectChange" :columns="columns" :listUrl="'/admin/knowledge/list'" ref="customList">
      <template v-slot:listOperate>
        <Button type="primary" icon="md-add" @click="showDialog">添加</Button>
      </template>
    </customList>
    <Modal
      title="添加知识"
      v-model="settleModalstatus"
      :mask-closable="false"
      :width="500"
      @on-cancel="closeSettleModal"
    >
      <div>
        <CustomForm :title="''" :dataArr="createObjArr" :model="createObj" :defaultSpan="24" :labelWidth="100"/>
      </div>
      <div slot="footer">
        <Button @click="closeSettleModal">取消</Button>
        <Button type="primary" @click="submitSettle">添加</Button>
      </div>
    </Modal>
    <Modal
      title="修改知识"
      v-model="settleUpdateModalstatus"
      :mask-closable="false"
      :width="500"
      @on-cancel="closeUpdateModal"
    >
      <div>
        <CustomForm :title="''" :dataArr="createObjArr" :model="updateObj" :defaultSpan="24" :labelWidth="100"/>
      </div>
      <div slot="footer">
        <Button @click="closeUpdateModal">取消</Button>
        <Button type="primary" @click="submitUpdate">修改</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getDataFromConfig } from '../../../assets/js/share';
const createObjArr = [
  {
    label: '问题',
    key: 'ques',
    verify: [
      {
        required: true
      }
    ]
  },
  {
    label: '回复',
    key: 'reply',
    type: 'textarea',
    verify: [
      {
        required: true
      }
    ]
  }
];
const createObj = getDataFromConfig(createObjArr); // 通过getDataFromConfig方法推导出模型对象
const updateObj = getDataFromConfig(createObjArr); // 通过getDataFromConfig方法推导出模型对象
export default {
  name: 'userList',
  data () {
    return {
      settleModalstatus: false,
      settleUpdateModalstatus: false,
      createObj,
      createObjArr,
      formItems: [
        { label: '问题', model: 'ques' },
        { label: '回答', model: 'reply' },
        { type: 'select', label: '状态', model: 'delStatus', options: [{ name: '全部', value: '' }, { name: '可用', value: 0 }, { name: '禁用', value: 1 }], fun: 'selectChange' },
        { type: 'button', buttonArr: [{ message: '查询', type: 'primary', fun: 'selectChange' }] }
      ],
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '问题', key: 'ques', fixed: 'left' },
        { title: '回答', key: 'reply', minWidth: 300 },
        { title: '创建者', key: 'user_name', width: 60 },
        {
          title: '创建时间',
          key: 'create_time',
          width: 130,
          render: (h, params) => {
            const dbDatetime = new Date(params.row.create_time);
            return h('div', [
              h('span', {}, params.row.create_time ? dbDatetime.toLocaleString() : '')
            ]);
          }
        },
        {
          title: '更新时间',
          key: 'update_time',
          width: 130,
          render: (h, params) => {
            const dbDatetime = new Date(params.row.update_time);
            return h('div', [
              h('span', {}, params.row.update_time ? dbDatetime.toLocaleString() : '')
            ]);
          }
        },
        {
          title: '操作',
          key: 'groupName',
          width: 110,
          fixed: 'right',
          render: (h, params) => {
            const buttonArr = [];
            buttonArr.push(
              h(
                'Button',
                {
                  props: { type: 'info', size: 'small' },
                  on: {
                    click: () => {
                      const obj = {
                        ques: params.row.ques,
                        reply: params.row.reply,
                        qaId: params.row.qa_id
                      };
                      this.updateObj = Object.assign({}, obj);
                      this.settleUpdateModalstatus = true;
                    }
                  }
                },
                '修改'
              )
            );
            return h('div', { }, buttonArr);
          }
        }
      ]
    };
  },
  methods: {
    showDialog () {
      this.settleModalstatus = true;
    },
    closeSettleModal () {
      this.settleModalstatus = false;
    },
    closeUpdateModal () {
      this.settleUpdateModalstatus = false;
    },
    submitSettle () {
      const { ques, reply } = this.createObj;
      const params = {
        ques,
        reply
      };
      const url = '/admin/knowledge/add';
      this.$ajax.post(url, { params }).then((data) => {
        if (data.data && data.data.status === 200) {
          this.$Message.success('添加成功');
          this.$refs.customList.searchTableInfo();
        }
        this.settleModalstatus = false;
      }).catch(() => {
        this.$Message.error('添加失败');
      });
    },
    submitUpdate () {
      const { ques, reply, qaId } = this.updateObj;
      const params = {
        ques,
        reply,
        qaId
      };
      const url = '/admin/knowledge/update';
      this.$ajax.post(url, { params }).then((data) => {
        if (data.data && data.data.status === 200) {
          this.$Message.success('修改成功');
          this.$refs.customList.searchTableInfo();
        }
        this.settleModalstatus = false;
      }).catch(() => {
        this.$Message.error('修改失败');
      });
    }
  },
  mounted () {
    this.columns.forEach((item) => {
      this.$set(item, 'align', 'center');
    });
  }
};
</script>
<style scoped>
</style>
